import _ from 'lodash';
import { IFileDescriptor } from '@wix/media-platform-js-client/dist/mjs/src/platform/management/metadata/file-descriptor';

import { PromiseState } from 'react-refetch';
import {
  GetFilesResponse,
  OpenFolderResponse,
  UploadFileSuccessPayload,
} from '../../../types/media-assets';
import { getParentFolder, normalize } from '../../../utils/path/path';
import { JobEventPayload } from '../../jobs/jobs.actions';
import { JobStatus, JobTypes } from '../../jobs/jobs.types';

export interface CurrentFolderState {
  path: string;
  loadState: PromiseState;
  idsList: string[];
}

export const currentFolderDefaultState: CurrentFolderState = {
  path: '/',
  idsList: [],
  loadState: PromiseState.create(),
};

export function setCurrentPath(
  state: CurrentFolderState,
  path: string,
): CurrentFolderState {
  return {
    ...state,
    path,
  };
}

export function setLoadedFiles(
  state: CurrentFolderState,
  { files, path }: OpenFolderResponse,
): CurrentFolderState {
  return {
    path,
    loadState: PromiseState.resolve(),
    idsList: _.map(files, 'id'),
  };
}

export function setLoadingError(
  state: CurrentFolderState,
  payload: any,
): CurrentFolderState {
  return {
    ...state,
    loadState: PromiseState.reject(payload),
    idsList: [],
  };
}

export function appendLoadedFiles(
  state: CurrentFolderState,
  { files, path }: GetFilesResponse,
): CurrentFolderState {
  if (path !== state.path) {
    return state;
  }

  return {
    ...state,
    idsList: [...state.idsList, ..._.map(files, 'id')],
  };
}

export function appendCreatedMediaAsset(
  state: CurrentFolderState,
  { id, path }: IFileDescriptor,
): CurrentFolderState {
  if (getParentFolder(path) !== normalize(state.path)) {
    return state;
  }

  return {
    ...state,
    idsList: [id, ...state.idsList],
  };
}

export function deleteFile(
  state: CurrentFolderState,
  { id }: any,
): CurrentFolderState {
  return {
    ...state,
    idsList: _.without(state.idsList, id),
  };
}

export function appendUploadedFile(
  state: CurrentFolderState,
  { file, parentFolderPath }: UploadFileSuccessPayload,
): CurrentFolderState {
  if (parentFolderPath !== state.path) {
    return state;
  }

  return {
    ...state,
    idsList: [file.id, ...state.idsList],
  };
}

export function appendFileCreatedByJob(
  state: CurrentFolderState,
  { job }: JobEventPayload<any>,
): CurrentFolderState {
  if (job.status !== JobStatus.SUCCESS || !job.result) {
    return state;
  }

  switch (job.type) {
    case JobTypes.ArchiveCreate:
      return appendCreatedMediaAsset(
        state,
        job.result.payload as IFileDescriptor,
      );

    default:
      return state;
  }
}
